<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('product.products') }}
        </span>
        <h3 class="page-title">
          {{ $t('product.tag.addNewTagCategory') }}
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/produkty/tagi')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('product.tag.addTagCategory') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <validation-observer ref="category-new-form" tag="form">
        <d-card class="mb-5">
          <d-tabs card v-if="!loadError">
            <!-- Dane ogólne -->
            <d-tab
              :title="$t('ui.generalInfo')"
              active>
              <h4 class="mb-3 pb-3 border-bottom">
                {{ $t('ui.generalInfo') }}
              </h4>

              <div class="form-group">
                <label>
                  {{ $t('product.tag.categoryName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="name" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <d-checkbox
                  inline
                  toggle-small
                  v-model="is_main"
                  toggle>
                  {{ $t('product.tag.isMain') }}
                </d-checkbox>
              </div>
            </d-tab>

            <d-tab :title="$t('ui.tags')">
              <p class="text-center">
                {{ $t('product.tag.tagManagemnetAvailableAfterCategorySave') }}
              </p>
            </d-tab>

            <d-tab
              :disabled="true"
              :title="$t('product.tag.mainCategories')">
            </d-tab>

            <d-tab
              :disabled="true"
              :title="$t('product.tag.categoryTranslations')">
            </d-tab>

            <d-tab
              :disabled="true"
              :title="$t('product.tag.tagTranslations')">
            </d-tab>
          </d-tabs>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
            {{ $t('ui.dataLoading') }}&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
          </d-alert>
        </d-card>
      </validation-observer>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'category-new',
  computed: {
    allDataLoaded () {
      return true;
    }
  },
  data() {
    return {
      name: '',
      is_main: false,
      loadError: false
    };
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['category-new-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = {
        name: this.name,
        is_main: this.is_main
      };

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/tags/categories/store',
        formData: formDataToSend,
        successTitle: this.$t('product.tag.addCategorySuccessTitle'),
        successText: this.$t('product.tag.addCategorySuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('product.tag.addCategoryErrorText'),
        successAction: (responseData) => {
          this.$router.push('/produkty/tagi/edycja/' + responseData.id);
        }
      });
    }
  }
};
</script>
